import styled from 'styled-components';
import tw from 'twin.macro';

import { StickyHeader as StickyHeaderImpl } from '@/atoms/StickyHeader';
import { StickyTableHeader } from '@/components/Atoms/StickyTableHeader';
import { Breadcrumb as BreadcrumbImpl } from '@/components/Breadcrumb';
import type { ServerSortMap, SortType } from '@/types';

const QUERY_KEY = 'people';

const BREADCRUMB_MAPPING = {
  contacts: 'Manage Contacts',
  ':id': 'Contact',
};

const Container = styled.section`
  ${tw`my-4 space-y-6 col-span-full xl:col-4/-1`}
`;

const IconWrapper = styled.span`
  ${tw`w-4 h-4`}

  svg {
    ${tw`w-full h-full`}
  }
`;

const StickyHeader = styled(StickyHeaderImpl)`
  ${tw`space-y-6`}
`;

const ActionHeader = styled(StickyTableHeader)`
  ${tw`top-[161px]`}
`;

const Breadcrumb = (): JSX.Element => (
  <BreadcrumbImpl
    mapping={BREADCRUMB_MAPPING}
    skipPathFragment={['settings', ':contactId']}
  />
);

const TableRenderer = styled.div`
  .td {
    ${tw`self-start`}

    &:last-child {
      ${tw`pt-1!`}
    }
  }
`;

const getMessage = (
  type: 'merge' | 'move' | 'split',
  success: boolean
): [string, string[]] => {
  switch (type) {
    case 'merge': {
      if (success) {
        return [
          'Contacts have been merged successfully',
          ['Contacts have been merged successfully'],
        ];
      } else {
        return ['Error when trying to merge the contact', ['Error']];
      }
    }
    case 'move': {
      if (success) {
        return [
          'Contact has been moved successfully',
          ['Contact has been moved successfully'],
        ];
      } else {
        return ['Error when trying to moving the contact', ['Error']];
      }
    }
    case 'split': {
      if (success) {
        return ['Your new contact is created', ['Your new contact is created']];
      } else {
        return ['Error when creating the contact', ['Error']];
      }
    }
    default:
      throw new Error(`${type} not handled`);
  }
};

const serverSortMap: ServerSortMap = ({ desc, id }) => {
  const sort: SortType = { order: 'asc', sort: id };

  return { ...sort, order: desc ? 'desc' : 'asc' };
};

export {
  QUERY_KEY,
  getMessage,
  ActionHeader,
  Breadcrumb,
  Container,
  IconWrapper,
  TableRenderer,
  serverSortMap,
  StickyHeader,
};
